import { Vue } from "vue-property-decorator";

import "./bootstrap/components";
import "./bootstrap/http";
import "./bootstrap/style";
import "./bootstrap/vee-validate";

import i18n from "./bootstrap/localisation";

import SignatureService from "./services/signatureService";
import UserService from "./services/user";

const signatureService = new SignatureService();
const userService = new UserService();

import App from "./main.vue";

import router from "./router";
import store from "./store";

import "@/store/loadModules";

import Snotify from "vue-snotify";
import VuejsDialog from "vuejs-dialog";
Vue.use(Snotify);
Vue.use(VuejsDialog);

Vue.config.productionTip = true;

new Vue({
  i18n,
  provide: {
    signatureService: () => signatureService,
  },
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
